/**
 * 管理后台会话标记（不是密钥）。
 * 真正的登录钥匙在 httpOnly Cookie 里，脚本读不到。
 */
const SESSION_FLAG = 'admin_session'
/** 历史本地令牌键：只清不读 */
const DEAD_TOKEN_KEY = 'admin_token'

function scrubDeadToken () {
  try { localStorage.removeItem(DEAD_TOKEN_KEY) } catch (_) { /* ignore */ }
}

export function hasSession () {
  try {
    return localStorage.getItem(SESSION_FLAG) === '1'
  } catch (_) {
    return false
  }
}

export function markSession () {
  try { localStorage.setItem(SESSION_FLAG, '1') } catch (_) { /* ignore */ }
  scrubDeadToken()
}

export function clearSession () {
  try { localStorage.removeItem(SESSION_FLAG) } catch (_) { /* ignore */ }
  scrubDeadToken()
}
